<template lang="pug">
  #app
    router-view
    //- footer-box
</template>

<script>
  import FooterBox from '@/views/FooterBox'
  export default {
    components: {
      FooterBox
    },
    name: 'app',
    created () {
      let self = this
      window.addEventListener('resize', () => {
        self.$root.screenW = window.innerWidth
        self.$root.screenH = window.innerHeight
      })
      self.$root.screenW = window.innerWidth
      self.$root.screenH = window.innerHeight
    },
    destroyed () {
      let self = this
      window.removeEventListener('resize', () => {
        self.$root.screenW = window.innerWidth
        self.$root.screenH = window.innerHeight
      })
    },
  }
</script>